<template>
  <div class="ReportCard">
       <div class="bg-img">
            <img v-lazy="item.coverurl" :alt="item.subject">
        </div>
        <p class="msg">{{item.subject}}</p>
  </div>
  <!-- 报告card 组件 -->
</template>

<script>
export default {
  name: 'ReportCard',
  props: ['item'],
  data () {
    return {}
  },
  mounted () {},
  methods: {},
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.ReportCard {
        float: left;
        padding: 20px;
        width: 189px;
        cursor: pointer;
        &:hover {
            transition: all 0.5s;
            -webkit-transition: all 0.5s;
            -ms-transition: all 0.5s;
            -moz-transition: all 0.5s;
            -o-transition: all 0.5s;
            box-shadow:0px 0px 6px 0px rgba(0,0,0,0.1);
            -ms-box-shadow:0px 0px 6px 0px rgba(0,0,0,0.1);
            -webkit-box-shadow:0px 0px 6px 0px rgba(0,0,0,0.1);
            -moz-box-shadow:0px 0px 6px 0px rgba(0,0,0,0.1);
            -o-box-shadow:0px 0px 6px 0px rgba(0,0,0,0.1);
        }
        .bg-img {
            position: relative;
            cursor: pointer;
                    img {
                        position: relative;
                        z-index: 2;
                        width: 190px;
                        height: 112px;
                    }
                    &::after {
                    content: '';
                        position: absolute;
                        top: 0;
                        display: block;
                        width: 196px;
                        height:112px;
                        background-image: url('./../../../../common/images/report/index/img_bg.png');
                        background-size: 100%;
                    }
        }
        &:hover {
          .msg {
            color: #409EFF;
          }
        }
        .msg {
            margin-top: 12px;
            font-size: 14px;
            line-height: 18px;
            height: 54px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            word-break: break-all;
           
        }
}

</style>